module.exports = __webpack_public_path__ + "assets/4b88707cdce0fa47853c9e4dadf4c589.png";